export default "__VITE_ASSET__ljq$Mc1l__"